import { FC } from 'react';

import CorrectDosage from '@/fo/icons/base/subscription-claims/correct-dosage.svg';
import Expertise from '@/fo/icons/base/subscription-claims/expertise.svg';
import MadeInFrance from '@/fo/icons/base/subscription-claims/made-in-france.svg';
import ManufacturerProducts from '@/fo/icons/base/subscription-claims/manufacturer-products.svg';
import { UiModSliderFading } from '@/fo/ui/mod/slider/fading';

import { styles } from './Claims.styles';

type ClaimComponent = FC<React.SVGProps<SVGElement>>;

export interface ClaimsProps {
  className?: string;
  claimsList?: {
    id: number;
    component: ClaimComponent;
  }[];
  isSubscribed: boolean;
}

const DEFAULT_CLAIM_LIST = [
  { id: 1, component: MadeInFrance },
  { id: 2, component: Expertise },
  { id: 3, component: CorrectDosage },
  { id: 4, component: ManufacturerProducts }
];

export function Claims({
  className,
  claimsList = DEFAULT_CLAIM_LIST,
  isSubscribed
}: ClaimsProps) {
  const slots = styles({ isSubscribed });
  return (
    <div className={slots.base({ className })}>
      <UiModSliderFading
        className={slots.slider()}
        containerClassName={slots.container()}
      >
        {claimsList.map(({ id, component: Claim }) => (
          <div key={id}>
            <Claim className={slots.claim()} />
          </div>
        ))}
      </UiModSliderFading>
    </div>
  );
}
